export default __webpack_public_path__ + "static/mix-39a98d43d9f4afd6f06a2939535802a3.png";